import {LoginApi, LoginPageGetHeartbeat} from '../../apis/user/login';
import {Button, Carousel, Image, Input, Layout, message, Row, Space} from 'antd';
import {InfoCircleOutlined, MobileOutlined} from '@ant-design/icons';
import React from 'react';
import {GetUserLoginVerifyCodeApi} from '../../apis/common';
import {GetLoginVerifyCode, VerifyCodeLogin} from '../../apis/user/user';
const {Sider, Content} = Layout;

export function VerifyCodeLoginRoute() {
    LoginPageGetHeartbeat()
    return (
        <>
            <Content width={'180'} style={{
                position: 'fixed',
                //overflow: 'auto',
                height: '100vh',
                left: 0,
                backgroundColor: 'gray',
                right: 400
            }}>
                <LoginPageCarousel></LoginPageCarousel>
            </Content>
            <VerifyCodeLoginPageSiderContent></VerifyCodeLoginPageSiderContent>
        </>
    );
}

export function LoginRoute() {
    LoginPageGetHeartbeat()
    return (
        <>
            <Content width={'180'} style={{
                position: 'fixed',
                //overflow: 'auto',
                height: '100vh',
                left: 0,
                backgroundColor: 'gray',
                right: 400
            }}>
                <LoginPageCarousel></LoginPageCarousel>
            </Content>
            <LoginPageSiderContent></LoginPageSiderContent>
        </>
    );
}

export function LoginPageCarousel() {

    const imageFallBack = 'fallback="data:image/png;base64,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"'

    return (
        <Carousel autoplay={true} dotPosition={'bottom'} dots={true} easing={'linear'}>
            <div>
                <Image
                    src={"https://startops-static.oss-cn-hangzhou.aliyuncs.com/devops/cool-geometric-triangular-figure-neon-laser-light-great-backgrounds.jpg"}
                    fallback={imageFallBack}
                    style={{
                        width: "100%",
                        height: "100vh",
                        //objectFit: "cover"
                    }}
                />
            </div>
            <div>
                <Image
                    src={"https://startops-static.oss-cn-hangzhou.aliyuncs.com/devops/cool-geometric-triangular-figure-neon-laser-light-great-backgrounds.jpg"}
                    fallback={imageFallBack}
                    style={{
                        width: "100%",
                        height: "100vh",
                        //objectFit: "cover"
                    }}
                />
            </div>
        </Carousel>
    );
}

function LoginPageSiderContent() {
    return (
        <Sider style={{
            position: 'fixed',
            overflow: 'auto',
            height: '100vh',
            //width: '30vh',
            //left: 180,
            right: 100,
            marginTop: 120
            //top: 30,
            //backgroundColor: "black",
        }}>
            <Row justify={'center'}>
                <Input
                    placeholder={'手机号码'}
                    prefix={<MobileOutlined/>}
                    id={'phone'}
                />
            </Row>
            <Row justify={'center'}>
                <Input.Password
                    placeholder={'密码'}
                    prefix={<InfoCircleOutlined/>}
                    id={'password'}
                />
            </Row>
            <Row justify={'center'}>
                <Button href={'/register'}>注册</Button>
                <Button onClick={LoginApi}>登录</Button>

                <Button href={"/verify/login"}>验证码登录</Button>

                <Button href={"/forgot"}>忘记密码</Button>

            </Row>
        </Sider>);
}



function VerifyCodeLoginPageSiderContent() {
    //
    const getLoginVerifyCodeOnClick = () => {

        const phoneNumber = document.getElementById("phoneNumber").value
        if (phoneNumber === "" || phoneNumber === undefined) {
            message.error(`请输入手机号码`)
            return
        }
        GetLoginVerifyCode({
            phoneNumber: phoneNumber,
        }).then(
            data => {
                let errCode = data.errCode
                let errMsg = data.errMsg
                if (errCode === 0) {
                    //const d = data.data
                    message.info(`获取登录验证码成功`)
                    return
                }

                message.error(`获取登录验证码失败 ${errMsg}`)
            }
        ).catch(
            err => {
                message.error(`获取登录验证码失败 ${err}`)
            }
        )
    }

    //
    const verifyCodeLoginOnClick = () => {
        const phoneNumber = document.getElementById("phoneNumber").value
        const verifyCode = document.getElementById("loginVerifyCode").value

        if (phoneNumber === "" || phoneNumber === undefined) {
            message.error(`请输入手机号码`)
            return
        }

        VerifyCodeLogin(
            {
                phoneNumber: phoneNumber,
                verifyCode: verifyCode,
            }
        ).then(
            data => {
                let errCode = data.errCode
                let errMsg = data.errMsg
                if (errCode === 0) {
                    let token = data.data.token
                    let userUuid = data.data.userUuid

                    // 登录成功
                    window.localStorage.setItem('token', token)
                    window.localStorage.setItem('userUuid', userUuid)
                    window.location.reload()
                    message.error('登录成功')
                    window.location.href = '/'

                    return
                }

                message.error(`验证码登录失败 ${errMsg}`)
            }
        ).catch(
            err => {
                message.error(`验证码登录失败 ${err}`)
            }
        )
    }

    return (
        <Sider style={{
            position: 'fixed',
            overflow: 'auto',
            height: '100vh',
            //width: '30vh',
            //left: 180,
            right: 100,
            marginTop: 120
            //top: 30,
            //backgroundColor: "black",
        }}>

            <Row justify={'center'}>
                <Space>
                    <Input
                        placeholder={'手机号码'}
                        prefix={<MobileOutlined/>}
                        id={'phoneNumber'}
                    />

                </Space>
            </Row>
            <Row justify={'center'}>
                <Space>
                    <Input
                        placeholder={'登录验证码'}
                        prefix={<MobileOutlined/>}
                        id={'loginVerifyCode'}
                    />

                    <Button type={'primary'} onClick={getLoginVerifyCodeOnClick}>验证码</Button>
                </Space>
            </Row>


            <Row justify={'center'}>
                <Button href={'/register'}>注册</Button>
                <Button onClick={verifyCodeLoginOnClick}>登录</Button>

                <Button href={"/login"}>密码登录</Button>

                <Button href={"/forgot"}>忘记密码</Button>

            </Row>
        </Sider>);
}